<template>
  <div class="pack-download-report-tip-div" v-if="packItemList && packItemList.length > 0">
    <svg class="icon mini icon-pack-info" aria-hidden="true">
      <use xlink:href="#icon-info"></use>
    </svg>
    <span class="tip-info-span">{{packItemList.length}}个文件正在批量打包下载，请不要关闭或刷新浏览器</span>
    <span class="span-view-all" @click="showPackList = true" v-if="!showPackList">查看</span>
    <span class="span-close-view-all" @click="showPackList = false" v-else>查看</span>
    <div class="pack-download-list-div" v-if="packItemList && packItemList.length > 0 && showPackList">
      <div class="pack-download-item" v-for="(item, index) in packItemList" :key="index">
        <span class="pack-download-name" :title="item.compressFileName">{{item.compressFileName}}</span>
        <span class="pack-download-progress">{{item.compressProgress}}%</span>
      </div>
    </div>
  </div>
</template>

<script>

let vm;
export default {
  name: 'PackDownload',
  components: {
  },
  beforeCreate() {
    vm = this
  },
  data() {
    return {
      packItemList: [],
      showPackList: false,
    }
  },
  computed: {
  },
  mounted() {
  },
  methods: {
    doPackReportFile(url) {
      this.$api.post(url, {}).then(res => {
        if (!res.success) {
          vm.$message.error(res.info || '打包失败，请稍后再试');
          return;
        }
        if(vm.packItemList.length == 0){
          vm.showPackList = false;
        }
        vm.packItemList.push({compressTaskId: res.data.compressTaskId, compressDownloadUrl: res.data.compressDownloadUrl, compressFileName: res.data.compressFileName, compressProgress: 0});
        vm.timeOutQueryCompressState(res.data.compressTaskId, res.data.compressDownloadUrl);
      }).catch(error => {
        console.log(error);
        vm.$message.error("打包失败，请稍后再试")
      })
    },
    timeOutQueryCompressState: function(compressTaskId, compressDownloadUrl){
      setTimeout(function () {
        vm.queryCompressState(compressTaskId, compressDownloadUrl);
      }, 2000)
    },
    queryCompressState: function(compressTaskId, compressDownloadUrl){
      this.$api.post("/resapi/resource/download/queryCompressSate", {compressTaskId: compressTaskId}).then(res => {
        if (res.success && res.data.compressResult) {
          let packItem = vm.fetchPackItem(compressTaskId);
          if(null != packItem){
            vm.$set(packItem, "compressProgress", res.data.compressResult && res.data.compressResult.compressProgress ? res.data.compressResult.compressProgress : 0);
            if(res.data.compressResult.state == 2){
              vm.splicePackItem(compressTaskId);
              vm.downloadUseForm(compressDownloadUrl, {taskId: compressTaskId});
            }else if(res.data.compressResult.state == -1){
              vm.splicePackItem(compressTaskId);
              vm.$message.error("压缩异常");
            }else{
              vm.timeOutQueryCompressState(compressTaskId, compressDownloadUrl);
            }
          }else{
            vm.splicePackItem(compressTaskId);
            return vm.$message.error("打包失败，请稍后再试");
          }
        }else{
          vm.splicePackItem(compressTaskId);
          return vm.$message.error(res.info);
        }
      }).catch(error => {
        vm.splicePackItem(compressTaskId);
        console.error(error);
        vm.$message.error("打包失败，请稍后再试");
      })
    },
    downloadUseForm(url, param){
      let form = document.createElement('form')
      form.action = url
      form.method = 'get'
      form.style.display = 'none'
      for (let item in param) {
        let input = document.createElement('input')
        input.type = 'hidden'
        input.name = item
        input.value = param[item]
        form.appendChild(input)
      }
      document.body.appendChild(form)
      form.submit()
      document.body.removeChild(form)
    },
    fetchPackItem: function(compressTaskId){
      for(let i = 0; i < vm.packItemList.length; i++) {
        if (vm.packItemList[i].compressTaskId == compressTaskId) {
          return vm.packItemList[i];
        }
      }
      return null;
    },
    splicePackItem: function(compressTaskId){
      for(let i = 0; i < vm.packItemList.length; i++) {
        if (vm.packItemList[i].compressTaskId == compressTaskId) {
          vm.packItemList.splice(i, 1);
          break;
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pack-download-report-tip-div{
  width: 458px;
  height: auto;
  line-height: 50px;
  opacity: 1;
  background: #f5f7fa;
  border: 1px solid #DFE6ED;
  border-radius: 4px;
  display: block;
  position: fixed;
  top: 104px;
  right: calc(50% - 220px);
  z-index: 2;
  text-align: left;
}
.pack-download-report-tip-div .icon-pack-info{
  margin: 0 16px 0 12px;
}
.pack-download-report-tip-div .tip-info-span{
  color: #606366;
  font-size: 14px;
  font-weight: 400;
  min-width: 330px;
  display: inline-block;
}
.pack-download-report-tip-div .span-view-all{
  font-size: 12px;
  color: #20CCC6;
  background-repeat: no-repeat;
  background-position: right 0px center;
  cursor: pointer;
  background-image: url(../assets/resource-content/icon_show_list.png);
  display: inline-block;
  vertical-align: middle;
  background-size: 14px;
  margin-left: 20px;
  width: 40px;
  text-align: left;
}
.pack-download-report-tip-div .span-close-view-all{
  font-size: 12px;
  color: #20CCC6;
  background-repeat: no-repeat;
  background-position: right 0px center;
  cursor: pointer;
  background-image: url(../assets/resource-content/icon_close_list.png);
  display: inline-block;
  vertical-align: middle;
  background-size: 14px;
  margin-left: 20px;
  width: 40px;
  text-align: left;
}
.pack-download-list-div{
  height: auto;
  padding: 0 80px 0 46px;
  display: block;
  max-height: 130px;
  overflow-y: auto;
  line-height: normal;
  margin-bottom: 12px;
}
.pack-download-list-div .pack-download-item{
  margin-top: 8px;
}
.pack-download-list-div .pack-download-item:first-child{
  margin-top: 5px;
}
.pack-download-list-div .pack-download-name{
  color: #606366;
  font-size: 14px;
  display: inline-block;
  width: 278px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
.pack-download-list-div .pack-download-progress{
  display: inline-block;
  vertical-align: middle;
  color: #20CCC6;
  font-size: 14px;
}
</style>
